import { render } from "./FooterMenuItem.vue?vue&type=template&id=e8e507b2&scoped=true"
import script from "./FooterMenuItem.vue?vue&type=script&lang=js"
export * from "./FooterMenuItem.vue?vue&type=script&lang=js"

import "./FooterMenuItem.vue?vue&type=style&index=0&id=e8e507b2&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8e507b2"]])

export default __exports__